// frontend/src/components/legal/LegalPage.jsx
// Static legal page for the Pista app. Mirrors the content shown on the
// marketing site so users can review the documents before accepting them.

import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LegalTerms from "./LegalTerms";
import LegalPrivacy from "./LegalPrivacy";
import LegalCookies from "./LegalCookies";
import "./LegalPage.css";

const sections = [
  { id: "terms", title: "Terms & Conditions" },
  { id: "privacy", title: "Privacy Policy" },
  { id: "cookies", title: "Cookie Policy" },
];

function LegalPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-page-header">
        <button
          type="button"
          className="legal-back-button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
        <h1 className="legal-page-title">Legal Documents</h1>
      </div>

      <nav className="legal-toc" aria-label="Legal documents table of contents">
        <p className="legal-toc-heading">Table of contents</p>
        <ul className="legal-toc-list">
          {sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`} className="legal-toc-link">
                {section.title}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <main className="legal-content">
        <LegalTerms />
        <LegalPrivacy />
        <LegalCookies />
      </main>
    </div>
  );
}

export default LegalPage;
